import _ from 'lodash'

/**
 * fetched images 中，
 * 每一個 order 只留下寬度最大的
 * @param {Object[]} images - 商品圖片
 *
 */
export const getOrderUniqueImages = images => {
  const groupsByOrder = _.groupBy(images, 'order') || []

  const extractedImages = _.map(
    groupsByOrder,
    group => {
      const ascendingSorted = _.sortBy(group, ({ width }) => width)
      const lastIdx = ascendingSorted.length - 1
      const widest = _.get(ascendingSorted, lastIdx, {})
      return widest
    })

  return extractedImages
}

/**
   *  取得 order 1, 除了 1000x1000 外的所有圖片
   * @param {Object[]} images - 商品圖片
   */
export const getFirstOrderImages = images => {
  const firstOrderImages = images
    .filter(img => img.order === 1)
    .filter(img => img.width !== 1000)
    .sort((a, b) => b.width - a.width)

  return firstOrderImages
}

export const setModelImages = model => {
  const modelImages = _.get(model, 'images', [])
  const firstOrderImages = getFirstOrderImages(modelImages)
  const orderUniqueImages = getOrderUniqueImages(modelImages)

  const firstImgUrl = _.get(orderUniqueImages, '[0].url', '')

  model.firstOrderImages = {
    [firstImgUrl]: {
      defaultImages: firstOrderImages,
      currentImages: _.cloneDeep(firstOrderImages)
    }
  }

  model.images = orderUniqueImages
}
